/**
 * Determines the label group for a given prompt based on its key.
 *
 * @param {Object} prompt - The prompt object containing key information.
 * @param {string} [prompt.insightsKey] - The insights key of the prompt.
 * @param {string} [prompt.promptKey] - The prompt key of the prompt.
 * @returns {('What'|'Where'|'When'|null)} The label group: 'WHAT', 'WHERE', 'WHEN', or null if no match is found.
 */
export const getPromptLabelGroup = (prompt) => {
  const key = prompt?.insightsKey || prompt?.promptKey || '';

  if (/product|categories/i.test(key)) return 'What';
  if (/place|store|channel|retailer/i.test(key)) return 'Where';
  if (/date_range|transaction_dt/i.test(key)) return 'When';

  return null;
};

/**
 * Builds an array containing a purchased answer object based on the given prompt and purchase status.
 *
 * @param {Object} params - The parameters object.
 * @param {boolean} params.isPurchased - Indicates if the item is purchased.
 * @param {Object} params.prompt - The prompt object containing attributes.
 * @returns {Array<Object>} An array with a single answer object describing the purchase status.
 */
export const buildPurchasedAnswer = ({ isPurchased, prompt }) => {
  const value = isPurchased ? 1 : 2;
  const name = isPurchased ? 'Purchased' : 'Not Purchased';
  const attributeId = prompt.attributes?.[0]?.id || '';

  return [
    {
      attributeId,
      id: `${attributeId}:${value}`,
      is_fixed: false,
      name,
      prompt_desc: name,
      type: 9999,
    },
  ];
};
